/**
 * Pseudos generes (module pur, teste).
 *
 * Deux usages, un seul generateur : le pseudo propose au visiteur qui n'en a
 * pas saisi, et celui du bot de la partie rapide. Les deux doivent se lire
 * comme un nom de joueur : le bot n'est pas deguise, mais il n'est pas non plus
 * annonce par son pseudo. C'est l'icone robot qui le dit, cf. PlayerView.bot.
 *
 * Le resultat tient toujours dans NICKNAME_MAX_LENGTH : un pseudo tronque au
 * join serait un nom different de celui affiche a l'ecran de saisie.
 */
import { NICKNAME_MAX_LENGTH } from './constants.js';
/** Vocabulaire d'atelier : rien qui evoque un robot, ni un joueur reel. */
export const NICKNAME_WORDS = [
    'Ocre',
    'Fusain',
    'Sanguine',
    'Glacis',
    'Vermillon',
    'Indigo',
    'Cobalt',
    'Garance',
    'Cinabre',
    'Pastel',
    'Esquisse',
    'Vernis',
    'Sepia',
    'Emeraude',
    'Safran',
    'Bistre',
];
function pick(items, random) {
    const index = Math.min(items.length - 1, Math.max(0, Math.floor(random() * items.length)));
    return items[index];
}
/**
 * Pseudo « Vermillon 47 ». Le nombre evite que deux joueurs de la meme table
 * portent le meme nom, sans registre global : il n'y a rien de persiste ici.
 */
export function randomNickname(random = Math.random) {
    const word = pick(NICKNAME_WORDS, random);
    const number = 10 + Math.floor(random() * 90);
    return `${word} ${number}`.slice(0, NICKNAME_MAX_LENGTH);
}
/**
 * Pseudo du bot. Meme fabrique que celui d'un joueur : c'est voulu, le
 * marqueur visuel est ailleurs.
 */
export function randomBotNickname(random = Math.random) {
    return randomNickname(random);
}
//# sourceMappingURL=names.js.map